// extracted by mini-css-extract-plugin
export default {"topad-wrap":"umPp2","topad":"w5j5c","topad-content":"uZv2q"};